import { ErrorEntry } from '../types';

type ExtractFields<T> = T extends ErrorEntry<infer TField, any> ? TField : never;
type ExtractErrors<T, TField extends string> = T extends ErrorEntry<TField, infer TError> ? TError : never;
type FormattedErrors<T> = {
    [K in ExtractFields<T>]?: ExtractErrors<T, K>[];
};

export function formatErrorKeys<T extends ErrorEntry<any, any>>(errorKeys: T[]): FormattedErrors<T> {
    return errorKeys.reduce<FormattedErrors<T>>((acc, [key, value]) => {
        const existingValue = acc[key] || [];
        acc[key] = [...existingValue, value];
        return acc;
    }, {});
}
